module.exports = __webpack_public_path__ + "img/slide5_cyberteck.42ac50d5.png";